export const ADD_ANALYSIS = "ADD_ANALYSIS";

export function addAnalysis(rangeId, response) {
    return {
        type: ADD_ANALYSIS,
        rangeId,
        response
    };
}
